export const normalizeTargetRoleIds = (targetRole) => {
  if (!targetRole || targetRole === "ALL") return [];
  if (Array.isArray(targetRole)) return targetRole.map(String);
  return [String(targetRole)];
};

export const formatQuizTargetRoles = (targetRole, userRoles = []) => {
  if (!targetRole || targetRole === "ALL") return "All users";

  const ids = normalizeTargetRoleIds(targetRole);
  const labels = ids.map((id) => {
    const match = userRoles.find((role) => String(role._id) === id);
    return match?.name ?? match?.cname ?? id;
  });

  return labels.join(", ");
};
